import React from "react";
import { StaticQuery, graphql } from "gatsby";
import { Trans, useTranslation } from "react-i18next";
import SignUpButton from "../../SignUpButton";

const PartOfZipmex = (props) => {
  const { t } = useTranslation();
  return (
    <>
      <div id="part-of-zipmex" className="bg-light-grey">
        <div className="container">
          <div className="timeline-alt">
            <img src={props.imageTimeline.publicURL} alt="Timeline" />
          </div>
          <div className="text-center">
            <span
              data-sal="slide-up"
              data-sal-duration="400"
              data-sal-easing="ease-in-quad"
            >
              <Trans i18nKey="zmt.bePartOfZipmex.subTitle" components={[]} />
            </span>
            <h2
              data-sal="slide-up"
              data-sal-duration="400"
              data-sal-easing="ease-in-quad"
            >
              <Trans i18nKey="zmt.bePartOfZipmex.title" components={[]} />
            </h2>
          </div>

          <div className="row">
            <div className="col-lg-4 text-center">
              <div
                data-sal="slide-up"
                data-sal-duration="400"
                data-sal-easing="ease-in-quad"
                data-sal-delay="100"
              >
                <img
                  src={props.iconStep1.publicURL}
                  alt="Sign Up to Zipmex"
                  className="img-fluid"
                />
                <h3>
                  <Trans
                    i18nKey="zmt.bePartOfZipmex.step1"
                    components={[
                      <SignUpButton
                        className="part-of-zipmex-underline"
                        target="_blank"
                      >
                        Sign up
                      </SignUpButton>,
                    ]}
                  />
                </h3>
              </div>
            </div>
            <div className="col-lg-4 text-center">
              <div
                data-sal="slide-up"
                data-sal-duration="400"
                data-sal-easing="ease-in-quad"
                data-sal-delay="200"
              >
                <img
                  src={props.iconStep2.publicURL}
                  alt="Buy ZMTs on platform"
                  className="img-fluid"
                />
                <h3 className="pt-5 buy-zmt">
                  <Trans i18nKey="zmt.bePartOfZipmex.step2" components={[]} />
                </h3>
              </div>
            </div>
            <div className="col-lg-4 text-center">
              <div
                data-sal="slide-up"
                data-sal-duration="400"
                data-sal-easing="ease-in-quad"
                data-sal-delay="300"
              >
                <img
                  src={props.iconStep3.publicURL}
                  alt="Hold ZMTs for a fixed or flexible amount of time"
                  className="img-fluid"
                />
                <h3>
                  <Trans i18nKey="zmt.bePartOfZipmex.step3" components={[]} />
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default () => (
  <StaticQuery
    query={graphql`
      query {
        iconStep1: file(relativePath: { eq: "images/step-1.svg" }) {
          publicURL
        }
        iconStep2: file(relativePath: { eq: "images/step-2.svg" }) {
          publicURL
        }
        iconStep3: file(relativePath: { eq: "images/step-3.svg" }) {
          publicURL
        }
        imageTimeline: file(relativePath: { eq: "images/timeline.svg" }) {
          publicURL
        }
      }
    `}
    render={(data) => (
      <PartOfZipmex
        iconStep1={data.iconStep1}
        iconStep2={data.iconStep2}
        iconStep3={data.iconStep3}
        imageTimeline={data.imageTimeline}
      />
    )}
  />
);
